// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".membership-specifications {\n  padding: 2% 0 5% 0%;\n  color: #b1b7b7; }\n  .membership-specifications .m-item {\n    padding: 1% 0; }\n  .membership-specifications #m-section .field-specification {\n    display: flex;\n    align-items: center; }\n    .membership-specifications #m-section .field-specification img {\n      padding-right: 4%; }\n", ""]);
// Exports
module.exports = exports;
